import {Component, inject} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {NavigationComponent} from "@app/navigation/navigation.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: true,
    imports: [
      RouterOutlet,
      NavigationComponent,
    ]
})
export class AppComponent {
  private router = inject(Router);

  showNavigation = true;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlWithoutFragment = event.urlAfterRedirects.split('#')[0];

        this.showNavigation = !['/about', '/privacy-policy', '/terms-of-service'].some(
          path => urlWithoutFragment.startsWith(path)
        );

        const fragment = event.urlAfterRedirects.split('#')[1];
        if (fragment) {
          this.scrollToFragment(fragment);
        }
      }
    });
  }

  private scrollToFragment(fragment: string) {
    const element = document.getElementById(fragment);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
